import {
  LoadingOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { message, Upload, Image, Button } from "antd";
import React, { useState } from "react";
import { apiUrl } from "@utils/apoloClient";
import { useEffect } from "react";
import ImgCrop from "antd-img-crop";

const UploadFile = ({ value, onChange, crop, square }) => {
  const [fileList, setFileList] = useState([]);
  const [preview, setPreview] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);

  useEffect(() => {
    if (value)
      setFileList([
        {
          uid: value,
          name: value,
          status: "done",
          url: apiUrl + value,
        },
      ]);
  }, [value]);



  const uploadButton = (
    <div>

      {uploadLoading ? <LoadingOutlined /> : <PlusOutlined />}

      <div
        style={{
          marginTop: 8,
        }}
      >
        آپلود
      </div>
    </div>
  );

  const squareUploadButton = <Button icon={<UploadOutlined />}>آپلود</Button>;
 function uploadRequest(options) {
  const body = new FormData();
  body.append("file", options.file);
  setUploadLoading(true);

  fetch(apiUrl + "upload", {
    method: "POST",
    body,
  })
    .then(async (response) => {
      const data = await response.json().catch(() => null);
      console.log("upload response status:", response.status);
      console.log("upload response data:", data);

      if (!response.ok) {
        throw new Error(data?.message || "upload failed");
      }

      if (!data?.link) {
        throw new Error("server did not return link");
      }

      onChange(data.link);
      setFileList([
        {
          uid: data.link,
          name: data.link,
          status: "done",
          url: apiUrl + data.link,
        },
      ]);

      options.onSuccess?.(data);
    })
    .catch((err) => {
      console.error("upload error:", err);
      message.error("آپلود فایل با خطا مواجه شد");
      options.onError?.(err);
    })
    .finally(() => {
      setUploadLoading(false);
    });
}

  const onRemove = () => {
    setFileList([]);
    onChange(null);
  };
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error(`لطفا فقط فرمت jpeg یا  png ارسال کنید!!`);
      onRemove();
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error(`حجم عکس باید از 2 مگابایت کمتر باشد!!`);
      onRemove();
    }
    return isJpgOrPng && isLt2M;
  };
  const UploadBox = (
    <Upload
      className={fileList.length === 1 && "hideUploadSelect"}
      listType={square ? "picture-card" : "picture"}
      showUploadList={fileList.length === 1}
      beforeUpload={beforeUpload}
      maxCount={1}
      onPreview={() => {
        setPreview(true);
      }}
      customRequest={uploadRequest}
      onRemove={onRemove}
      fileList={fileList}
    >
      {fileList.length === 0 && square ? uploadButton : false}
      {!square && squareUploadButton}
    </Upload>
  );

  return (
    <>
      {crop ? (
        <ImgCrop rotate modalOk="خوبه" modalTitle="ویرایش" modalCancel="بیخیال">
          {UploadBox}
        </ImgCrop>
      ) : (
        UploadBox
      )}
      <Image
        preview={{
          visible: preview,
          scaleStep: 0.5,
          src: fileList[0]?.url,
          onVisibleChange: () => {
            setPreview(false);
          },
        }}
      />
    </>
  );
};
export default UploadFile;
